import {
  ERROR_OCCURRED,
  APP_VERSION
} from "./action";

const initialState = {
  is_error_occured: false,
  app_version: "1.0.47"
};

export const storeReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case APP_VERSION:
      return {
        ...state,
        app_version: action.payload
      }

    case ERROR_OCCURRED:
      return {
        ...state,
        is_error_occured: action.payload
      }


    default:
      return { ...initialState, ...state };
  }
};
